if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Rubik Variant Images: variant id -> media ids, printed by
			// sections/main-product.liquid from the craftshift.variantImages
			// metafield. Absent unless the app has configured this product.
			this.rubikVariantMedia = null;
			const rubikVariantMediaEl = this.querySelector('[data-js-rubik-variant-media]');
			if ( rubikVariantMediaEl ) {
				try {
					this.rubikVariantMedia = JSON.parse(rubikVariantMediaEl.textContent);
				} catch(e) {
					this.rubikVariantMedia = null;
				}
			}

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Product thumbnails
			this.querySelectorAll('[data-js-product-tabs]').forEach(tabs=>{
				tabs.querySelectorAll('label').forEach(tab=>{
					tab.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							tab.click();
						}
					});
				})
			})

			this.querySelectorAll('.product-variant__item--color').forEach(elm=>{
				const selectedColor = elm.querySelector('input[type="radio"][checked][data-selected]');
				if ( selectedColor ) {
					selectedColor.closest('[data-js-product-variant]').querySelector('.product-variant__item-text-label').innerHTML = selectedColor.value;
				}
			});

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', ()=>{
					this.productImageSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					this.productImages = this.productSlider.querySelectorAll('.product-media-image');
				});
				this.productSlider.addEventListener('scroll', ()=>{
					const scrollX = -this.productSlider.element.scrollLeft;
					this.productImageSlides.forEach((slide,i)=>{
						const img = this.productImages[i];
						if ( img ) {
							const slideX = slide.offsetLeft;
							img.style.transform = `translateX(${( slideX + scrollX ) * -1/3}px)`;
						}
					});
				});

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

				// The slider rebuilds itself from its original markup whenever it
				// is destroyed and re-enabled (crossing the 1024px watchCSS
				// boundary), which restores the media set as first rendered. Re-run
				// the filter so a resize cannot strand the wrong colour on screen.
				this.productSlider.addEventListener('ready', ()=>{
					if ( this.productVariants && this.productVariants.currentVariant ) {
						this.applyRubikVariantMedia(this.productVariants.currentVariant);
					}
				});

			}

			this.productGallery.querySelectorAll('[data-js-video-popup-link]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this._pauseAllMedia();
				});
			})

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this._isInitialLoad = true;
				this.onVariantChangeHandler({target:this.productVariants});
				this._isInitialLoad = false;

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}
			
			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {

				// hide buy now button if stock disabled

				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });

			}

			// truncated descriptions

			if ( this.querySelector('[data-js-show-more]') ) {
				const showMore = this.querySelector('[data-js-show-more]');
				const productDescription = this.querySelector('.product__description');
				showMore.addEventListener('click', ()=>{
					productDescription.classList.toggle('product__description--truncated-initial');
					if ( productDescription.classList.contains('product__description--truncated-initial') ) {
						showMore.querySelector('.button__text').textContent = showMore.dataset.labelShowLess;
					} else {
						showMore.querySelector('.button__text').textContent = showMore.dataset.labelShowMore;
					}
				})
			}

			// recommended products
			
			this.querySelector('product-recommendations')?.addEventListener('product-recommendations-loaded', ()=>{
				this.querySelector('product-recommendations').classList.add('product-text-element--with-borders');
			});
			this.querySelector('product-recommendations')?.addEventListener('product-recommendations-error', ()=>{
				this.querySelector('product-recommendations').remove();
			});

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		applyRubikVariantMedia(variant){

			// Show only the media the Rubik Variant Images app assigned to this
			// variant. Every slide stays in the DOM; what changes is the
			// .product-gallery-item class, which is the slider's slide selector
			// ("selector": ".product-gallery-item" in the css-slider options), so
			// dropping it takes a slide out of the slider's index maths entirely
			// rather than leaving a zero-width gap in it.
			//
			// Nothing is replaced or re-fetched, so every listener this component
			// bound in its constructor stays attached.

			if ( ! this.rubikVariantMedia || ! variant || ! this.productGallery ) return false;

			const wanted = this.rubikVariantMedia[String(variant.id)];
			if ( ! wanted || ! wanted.length ) return false;

			const keep = wanted.map(String);
			const slides = this.productGallery.querySelectorAll('[data-product-single-media-wrapper]');
			if ( ! slides.length ) return false;

			// Never empty the gallery: if none of this variant's ids match a
			// slide (images deleted since they were assigned), leave it alone.
			if ( ! Array.prototype.some.call(slides, slide=>keep.indexOf(String(slide.dataset.mediaId)) !== -1) ) return false;

			const cssSlide = (window.KT_PREFIX || '') + 'css-slide';
			let changed = false;

			slides.forEach(slide=>{
				const show = keep.indexOf(String(slide.dataset.mediaId)) !== -1;
				if ( show === slide.classList.contains('product-gallery-item') ) return;
				changed = true;
				if ( show ) {
					slide.classList.add('product-gallery-item');
					// initSlider only stamps css-slide on the slides present at
					// init, so a slide revealed later has to be given it here.
					slide.classList.add(cssSlide);
					slide.removeAttribute('hidden');
					slide.removeAttribute('aria-hidden');
					slide.style.removeProperty('display');
				} else {
					slide.classList.remove('product-gallery-item');
					slide.setAttribute('hidden', '');
					slide.setAttribute('aria-hidden', 'true');
					slide.style.setProperty('display', 'none');
				}
			});

			// Renumber so data-index runs 0..n-1 over the visible slides. The
			// slider redoes this for its snap slides on reset, but the scroll
			// layout on desktop has no slider running and still reads data-index.
			let visible = 0;
			slides.forEach(slide=>{
				slide.setAttribute('data-index', slide.classList.contains('product-gallery-item') ? visible++ : -1);
			});

			// Thumbnails are a second loop over the same media, paired by id.
			const thumbs = this.querySelectorAll('.product-gallery__thumbnails .thumbnail[data-media-id]');
			let visibleThumb = 0;
			thumbs.forEach(thumb=>{
				const show = keep.indexOf(String(thumb.dataset.mediaId)) !== -1;
				if ( show ) {
					thumb.removeAttribute('hidden');
					thumb.removeAttribute('aria-hidden');
					thumb.style.removeProperty('display');
					thumb.setAttribute('data-index', visibleThumb++);
				} else {
					thumb.setAttribute('hidden', '');
					thumb.setAttribute('aria-hidden', 'true');
					thumb.style.setProperty('display', 'none');
					thumb.setAttribute('data-index', -1);
				}
			});

			const total = this.productGallery.querySelector('[data-js-slider-total]');
			if ( total ) {
				total.textContent = visible;
			}

			if ( ! changed ) return false;

			const slider = this.productGallery.querySelector('css-slider');
			if ( slider && slider.sliderEnabled ) {
				// Public methods: afterAppend re-reads the slide set, resetSlider
				// rebuilds indices, page count and navigation from it.
				slider.afterAppend();
				slider.resetSlider();
				// resetSlider does not re-fire 'ready', so the parallax node lists
				// this component caches there have to be refreshed by hand.
				this.productImageSlides = slider.querySelectorAll('.product-gallery-item');
				this.productImages = slider.querySelectorAll('.product-media-image');
			}

			this.thumbnailNavigationHelper(0);

			return true;

		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {

				// Rubik variant media first, so the image handling below is
				// looking at the slides this variant is actually meant to show.
				this.applyRubikVariantMedia(variant);

				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								if ( !this._isInitialLoad ) {
									this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
								}
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							if ( !this._isInitialLoad ) {
								variantImg.scrollIntoView({behavior: 'auto', block: 'center'});
							}
						}
					}
				}

			}

			this._pauseAllMedia();

		}

		_pauseAllMedia(){
			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI && model.modelViewerUI.pause ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

	if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}